import React from 'react';

import { TabelaTipoCursos } from '../../components/TabelaTipoCursos';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';

export default function CursosPage() {

  return (
    <>
      <MenuMain >
        <TabelaTipoCursos />
      </MenuMain>
      <AppFooter />
    </>
  );
}
